<section class="banner">
  <app-nav class="w-100"></app-nav>
  <div class="container-fluid mob-px-5 v4-adjustment">
    <div class="d-flex justify-content-between pt-5">
      <div class="d-flex">
        <img
          class="img-icon"
          src="../../../../../assets/v-4-icone/history.png"
          alt="loading"
        />
        <h2 class="font-600 v4-color-white">
          {{ "New Branch Training" | translator }}
        </h2>
      </div>
    </div>
    <div
      class="d-flex justify-content-between align-items-center flex-wrap my-3 mx-3 w-100"
    >
      <div class="d-flex flex-wrap">
        <span class="d-flex align-items-center">
          <span
            (click)="changeRoute('/home',[])"
            class="custom-bredcrum-btn d-flex align-items-center"
          >
            {{ "Homepage" | translator }}
          </span>
          <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
        </span>
        <span class="d-flex align-items-center">
          <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
            {{ "New Branch Training" | translator }}
          </span>
        </span>
      </div>
      <div class="d-flex flex-wrap">
        <ng-container *ngIf="addTrainingProgram == false">
          <div class="align-items-center d-flex flex-wrap">
            <a
              (click)="addTrainingProgram = true; createCourseModal = false"
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-plus-circle mx-2"></i
              >{{ "Add Training Program" | translator }}</a
            >

            <!-- <a
              (click)="createCourseModal = true; addTrainingProgram = false"
              *ngIf="hasPermission('NEW_BRANCH_TRAINING', 'c')"
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-plus-circle mx-2"></i
              >{{ "Create a training course" | translator }}</a
            > -->

            <a
              (click)="
                ShowDashboard = true;
                showCalender = false;
                addTrainingProgram = false;
                createCourseModal = false
              "
              *ngIf="hasPermission('NEW_BRANCH_TRAINING_DASHBOARD', 'r')"
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-chart-bar mx-2"></i
              >{{ "Show Dashboard" | translator }}</a
            >

            <a
              (click)="
                ShowDashboard = false;
                showCalender = false;
                addTrainingProgram = false;
                createCourseModal = false
              "
              *ngIf="hasPermission('NEW_BRANCH_TRAINING', 'r')"
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-list mx-2"></i>{{ "Show List" | translator }}</a
            >

            <a
              (click)="
                ShowDashboard = false;
                showCalender = true;
                addTrainingProgram = false;
                createCourseModal = false
              "
              *ngIf="hasPermission('NEW_BRANCH_TRAINING', 'r')"
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-calendar mx-2"></i
              >{{ "Show Calender" | translator }}</a
            >
          </div>
        </ng-container>

        <ng-container *ngIf="addTrainingProgram == true">
          <a
            (click)="addTrainingProgram = false; updateHolder = undefined"
            class="create-training-btn m-2 align-items-center d-flex"
            ><i class="pi pi-times-circle mx-2"></i
            >{{ "delete" | translator }}</a
          >
        </ng-container>
      </div>
    </div>
  </div>
</section>

<div class="container-fluid v4-bg p-0">
  <div class="pt-5">
    <ng-container
      *ngIf="
        !createCourseModal &&
        !openCourseModal &&
        !addTrainer &&
        !ShowDashboard &&
        !addTrainingProgram
      "
    >
      <ng-container>
        <ng-container *ngIf="selectedProgram">
          <div
            class="users-data-table d-flex justify-content-center container-fluid"
            [ngClass]="{ 'my-3': true }"
          >
            <div class="white-box container-fluid mb-5 p-0"></div>
          </div>
          <app-no-data
            [hidden]="selectedProgram?.courses?.length > 0"
          ></app-no-data>
        </ng-container>
      </ng-container>

      <!-- Trainings Not In Program -->
      <section class="container v4-select-bg">
        <div class="pt-3 d-flex justify-content-center">
          <div class="d-flex mx-2">
            <p-selectButton
              class="v4-active"
              styleClass="d-flex justify-content-center flex-wrap"
              (onChange)="getTrainingRequests()"
              [options]="statusOptions"
              [(ngModel)]="status"
              [multiple]="false"
              optionLabel="name"
              optionValue="value"
              filterButton
            ></p-selectButton>
          </div>
        </div>
        <div class="pt-3 d-flex justify-content-center flex-wrap">
          <div  class="mob-width-100"  >
            <p-treeSelect
            dir="ltr"
            filterButton
              class="ppp-tree-select"
              appendTo="body"
              class="w-md-20rem w-100"
              containerStyleClass="w-100"
              [(ngModel)]="oufilter"
              (onNodeSelect)="getTrainingRequests($event)"
              [options]="selectedTreeData"
              placeholder="{{ 'Select the organizational unit' | translator }}"
              [filter]="true"
              [filterInputAutoFocus]="true"
            >
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img
                    *ngIf="checkisImg(node.data); else elseBlock"
                    src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg"
                    style="max-height: 30px; max-width: 30px"
                  />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </div>

          <div class="mx-2" >
            <p-calendar
            filterButton
            dir="ltr"
              class="v4-calander"
              [(ngModel)]="DateRange"
              (ngModelChange)="onDateRangeChange()"
              selectionMode="range"
              placeholder="{{ 'Date Filter' | translator }}"
              [readonlyInput]="true"
            ></p-calendar>
          </div>

          <div class="v4-rotate">
            <i
              pTooltip="{{ 'Reset' | translator }}"
              (click)="refreshFilters()"
              tooltipPosition="top"
              class="fa-solid fa-arrows-rotate mx-3"
            ></i>
          </div>
        </div>
      </section>
      <section class="container-fluid">
        <div
          class="d-flex my-3 flex-wrap justify-content-center"
        >
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box PENDING"></span>
            <span class="color-txt mx-2">{{ "pending" | translator }}</span>
          </div>
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box APPROVED"></span>
            <span class="color-txt mx-2">{{ "Accepted" | translator }}</span>
          </div>
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box TRAINING_CREATED"></span>
            <span class="color-txt mx-2">{{ "Draft" | translator }}</span>
          </div>
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box REJECTED"></span>
            <span class="color-txt mx-2">{{ "Rejected" | translator }}</span>
          </div>
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box PUBLISHED"></span>
            <span class="color-txt mx-2">{{ "Published" | translator }}</span>
          </div>
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box COMPLETED"></span>
            <span class="color-txt mx-2">{{ "completed" | translator }}</span>
          </div>
        </div>
        <app-no-data
          [hidden]="spinner || filterRequestData?.length > 0"
        ></app-no-data>
        <!-- ================ -->

        <!-- ============= -->
        <div
          class="users-data-table d-flex justify-content-center container-fluid"
          [ngClass]="{ 'my-3': true }"
        >
          <div class="white-box container-fluid mb-5 p-0">
            <div [hidden]="spinner || filterRequestData?.length <= 0">
              <div class="grey-box">
                <div class="dynamic-table-main-tr">
                  <!-- Header -->
                  <div class="row f-table">
                    <div class="col-md-1 col-12">
                      <div class="v4-bold">#</div>
                    </div>
                    <div class="col-md-2 col-12">
                      <div class="v4-bold">
                        {{ "the address" | translator }}
                      </div>
                    </div>
                    <div class="col-md-2 col-12">
                      <div class="v4-bold">
                        {{ "Entities" | translator }}
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="v4-bold">
                        {{ "Description" | translator }}
                      </div>
                    </div>
                    <div class="col-md-2 col-12">
                      <div class="v4-bold">
                        {{ "the month" | translator }}
                      </div>
                    </div>
                    <div
                      *ngIf="status && status === 'CANCELED'"
                      class="col-md-2 col-12"
                    >
                      <div class="v4-bold">
                        {{ "the reason of refuse" | translator }}
                      </div>
                    </div>
                    <div class="col-md-2 col-12">
                      <div class="v4-bold">
                        {{ "Action" | translator }}
                      </div>
                    </div>
                  </div>
                  <!-- End Header -->
                  <ng-container
                    *ngFor="let request of filterRequestData; let i = index"
                  >
                    <!-- Training  -->
                    <ng-container *ngIf="!request.isProgram">
                      <div class="row px-2 mob-my-4">
                        <div class="col-md-1 col-12 p-0 3333">
                          <div class="tabel-detail-box adjustment">
                            <div class="d-flex">
                              <div
                                class="ms-tabel-num-box"
                                (click)="op.toggle($event)"
                              >
                                <i
                                  class="fa fa-solid fa-chalkboard-user f-2rem-user"
                                ></i>
                              </div>
                            </div>
                            <div class="d-flex bold">
                              {{ i + 1 }}
                            </div>
                          </div>
                        </div>

                        <div class="col-md-2 col-12 p-0">
                          <div class="tabel-detail-box">
                            <div class="tab-scroll">
                              {{ request?.trainingId?.title }}
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-md-2 col-12 p-0"
                          *ngIf="request?.ou; else ous"
                        >
                          <div class="tabel-detail-box">
                            <div class="tab-scroll">
                              {{ request?.ou?.name }} ({{
                                request?.ou?.location?.name
                              }})
                            </div>
                          </div>
                        </div>

                        <ng-template #ous>
                          <div class="col-md-2 col-12 p-0">
                            <div class="tabel-detail-box">
                              <div class="tab-scroll">
                                {{ getNamesString(request?.ous) }}
                              </div>
                            </div>
                          </div>
                        </ng-template>

                        <div class="col-md-3 col-12 p-0">
                          <div class="tabel-detail-box">
                            <div class="tab-scroll">
                              {{ request?.trainingId?.description }}
                            </div>
                          </div>
                        </div>

                        <div class="col-md-2 col-12 p-0">
                          <div class="tabel-detail-box">
                            <div class="tab-scroll d-flex align-items-center">
                              <div>
                                {{ request?.trainingId?.start_date | date }}
                              </div>
                              <div class="d-flex align-items-center mx-2">
                                <i class="full-stop"></i>
                                <div class="time-bar"></div>
                                <i class="pi pi-arrow-left icon-purple"></i>
                              </div>
                              <div>
                                {{ request?.trainingId?.end_date | date }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          *ngIf="status && status === 'CANCELED'"
                          class="col-md-2 col-12 p-0"
                        >
                          <div class="tabel-detail-box">
                            <div class="tab-scroll">
                              {{
                                request?.reason ?? request?.reason | safeHTML
                              }}
                            </div>
                          </div>
                        </div>

                        <div #targetEl class="col-md-2 col-12 p-0">
                          <div class="tabel-detail-box">
                            <div class="tab-scroll d-flex flex-wrap">
                              <div
                                pTooltip="{{ 'amendment' | translator }}"
                                tooltipPosition="top"
                                *ngIf="
                                  ((request.status === 'TRAINING_CREATED' ||
                                    request.status === 'PUBLISHED' ||
                                    request.status == 'COMPLETED') &&
                                    hasPermission(
                                      'NEW_BRANCH_TRAINING',
                                      'u'
                                    )) ||
                                  hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                                  materTrainerPermission(
                                    request?.master_trainer
                                  )
                                "
                                (click)="openCourse(request)"
                                class="tabel-circle-btn"
                              >
                                <i class="fa-solid fa-file-pen"></i>
                              </div>

                              <div
                                pTooltip="{{ 'Publish' | translator }}"
                                tooltipPosition="top"
                                *ngIf="
                                  request.status === 'TRAINING_CREATED' &&
                                  request.status != 'PUBLISHED' &&
                                  (hasPermission(
                                    'NEW_BRANCH_TRAINING_PUBLISH',
                                    'a'
                                  ) ||
                                    materTrainerPermission(
                                      request?.master_trainer
                                    ))
                                "
                                (click)="publish(request)"
                                class="tabel-circle-btn"
                              >
                                <i class="fa-solid fa-bullhorn"></i>
                              </div>

                              <div
                                pTooltip="{{ 'Assign Users' | translator }}"
                                tooltipPosition="top"
                                *ngIf="
                                  request.status == 'PUBLISHED' &&
                                  (hasPermission(
                                    'NEW_BRANCH_TRAINING_PUBLISH',
                                    'a'
                                  ) ||
                                    materTrainerPermission(
                                      request?.master_trainer
                                    ) )
                                "
                                (click)="addAttendees(request)"
                                class="tabel-circle-btn"
                              >
                                <i class="fa-solid fa-user-plus"></i>
                              </div>

                              <div
                                pTooltip="{{ 'User Management' | translator }}"
                                [hidden]="
                                  !(
                                    materTrainerPermission(
                                      request?.master_trainer
                                    )  ||
                                    hasPermission('NEW_BRANCH_TRAINING', 'r')
                                  )
                                "
                                (click)="
                                  changeRoute(
                                    '/training/user-management/',
                                      [request?.trainingId?._id]
                                  )
                                "
                                tooltipPosition="top"
                                class="tabel-circle-btn"
                              >
                                <i class="fa-solid fa-user-gear"></i>
                              </div>

                              <!-- <div
                                  pTooltip="{{ 'View' | translator }}"
                                  [hidden]="
                                    !(
                                      request.status === 'TRAINING_CREATED' ||
                                      request.status === 'PUBLISHED'
                                    ) &&
                                    !(
                                      materTrainerPermission(request?.master_trainer) ||
                                      this.managerPage ||
                                      hasPermission('NEW_BRANCH_TRAINING', 'r')
                                    )
                                  "
                                  (click)="openCourse(request, true)"
                                  tooltipPosition="top"
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa fa-eye"></i>
                                </div> -->

                              <div
                                pTooltip="{{ 'Delete training' | translator }}"
                                [hidden]="
                                  !hasPermission('NEW_BRANCH_TRAINING', 'd') &&
                                  !materTrainerPermission(
                                    request?.master_trainer
                                  )
                                "
                                tooltipPosition="top"
                                *ngIf="
                                  request.status !== 'PUBLISHED' &&
                                  request.status !== 'COMPLETED'
                                "
                                (click)="
                                  deleteRequest(request?.trainingId?._id)
                                "
                                class="tabel-circle-btn"
                              >
                                <i class="fa fa-trash"></i>
                              </div>

                              <div
                                pTooltip="{{ 'Add to Kl' | translator }}"
                                tooltipPosition="top"
                                *ngIf="
                                  (request.status === 'PUBLISHED' ||
                                    request.status == 'COMPLETED') &&
                                  (hasPermission('NEW_BRANCH_TRAINING', 'u') ||
                                    hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                                    materTrainerPermission(
                                      request?.master_trainer
                                    ))
                                "
                                (click)="
                                  selectKLCourse = request;
                                  openAddKLModal = true
                                "
                                class="tabel-circle-btn"
                              >
                                <i class="pi pi-book"></i>
                              </div>

                              <div
                                pTooltip="{{ 'Results' | translator }}"
                                tooltipPosition="top"
                                *ngIf="
                                  (request.status === 'PUBLISHED' ||
                                    request.status == 'COMPLETED') &&
                                  hasPermission(
                                    'NEW_BRANCH_TRAINING_PUBLISH',
                                    'a'
                                  )
                                "
                                class="tabel-circle-btn"
                                [routerLink]="
                                  '/training/training-results/' +
                                  request?.trainingId?._id
                                "
                                [queryParams]="{ back: '/training/new-branch' }"
                              >
                                <i class="pi pi-chart-bar"></i>
                              </div>

                              <div
                                class="tabel-circle-btn"
                                pTooltip="{{ 'Cancel training' | translator }}"
                                tooltipPosition="top"
                                *ngIf="
                                  request.status === 'PUBLISHED' &&
                                  (hasPermission('NEW_BRANCH_TRAINING', 'u') ||
                                    hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                                    materTrainerPermission(
                                      request?.master_trainer
                                    ))
                                "
                                (click)="
                                  rejectReason = true;
                                  rejectData.status = 'CANCELED';
                                  rejectData._id = request._id
                                "
                              >
                                <i class="fa-solid fa-ban"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p-overlayPanel
                        class="v4-p-overlay-panel"
                        [style]="{ width: '500px' }"
                        #op
                      >
                        <app-training-timeline
                          [sessions]="request?.trainingId?.sessions"
                          [isToolTip]="true"
                        ></app-training-timeline>
                      </p-overlayPanel>
                    </ng-container>
                    <!-- End Training  -->

                    <!-- Training Program -->
                    <ng-container *ngIf="request.isProgram">
                      <div
                        class="{{
                          selectedProgram?._id == request?._id
                            ? 'folder-open'
                            : 'folder'
                        }}"
                      >
                        <div class="">
                          <div class="row p-0">
                            <div class="col-md-1 col-12 p-0 1111">
                              <div class="tabel-detail-box adjustment">
                                <div class="d-flex">
                                  <div data-label="#" class="ms-tabel-num-box">
                                    <i
                                      class="pi pi-folder-open f-2rem"
                                      (click)="handleProgram(request)"
                                    ></i>
                                  </div>
                                </div>
                                <div class="d-flex bold">
                                  {{ i + 1 }}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2 col-12 p-0">
                              <div class="tabel-detail-box">
                                <div data-label="la wasuf" class="tab-scroll">
                                  {{ request?.title }}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2 col-12 p-0">
                              <div class="tabel-detail-box">
                                <div data-label="la wasuf" class="tab-scroll">
                                  {{ getNamesString(request?.ous) }}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3 col-12 p-0">
                              <div class="tabel-detail-box">
                                <div class="tab-scroll">
                                  {{ request?.description }}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2 col-12 p-0">
                              <div class="tabel-detail-box">
                                <div
                                  class="tab-scroll d-flex align-items-center"
                                >
                                  <div>{{ request?.end_date | date }}</div>
                                  <div class="d-flex align-items-center mx-2">
                                    <i class="full-stop"></i>
                                    <div class="time-bar"></div>
                                    <i class="pi pi-arrow-left icon-purple"></i>
                                  </div>
                                  <div>{{ request?.start_date | date }}</div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2 col-12 p-0">
                              <div class="tabel-detail-box">
                                <div class="tab-scroll d-flex flex-wrap">
                                  <span class="tabel-circle-btn">
                                    <i
                                    *ngIf="
                                        hasPermission('TRAINING_PROGRAM', 'u')
                                      "
                                      pTooltip="{{ 'Edit' | translator }}"
                                      (click)="updateTrainingProgram(request)"
                                      tooltipPosition="top"
                                      class="pi pi-file-edit"
                                      ></i>
                                    </span>
                                    <span
                                    *ngIf="
                                      request.status == 'PENDING' &&
                                      hasPermission('PROGRAM_PUBLISH', 'a')
                                    "
                                    class="tabel-circle-btn"
                                    >
                                    <i
                                    pTooltip="{{ 'delete'| translator }}"
                                    (click)="confirmProgramDelete(request)"
                                    tooltipPosition="top"
                                    class="pi pi-trash"
                                    ></i>
                                  </span>
                                  <span
                                  *ngIf="
                                    request.status == 'PENDING' &&
                                  (  hasPermission('TRAINING_PROGRAM', 'u') ||  hasPermission('PROGRAM_PUBLISH', 'a'))
                                  "
                                  class="tabel-circle-btn"
                                  >
                                  <i
                                  pTooltip="{{ 'Publish' | translator }}"
                                  (click)="confirmApprove(request)"
                                  tooltipPosition="top"
                                  class="pi pi-megaphone"
                                  ></i>
                                </span>
                                  <span
                                        pTooltip="{{ 'User Management' | translator }}"
                                        [hidden]="
                                          !(
                                            materTrainerPermission(request?.master_trainer) ||
                                            hasPermission('NEW_BRANCH_TRAINING', 'u')
                                          )
                                        "
                                        (click)="changeRoute('training/program-user-managment/',[request?._id])"
                                        tooltipPosition="top"
                                        class="tabel-circle-btn"
                                      >
                                        <i class="fa-solid fa-user-gear"></i>
                                      </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <p class="mb-2">{{ request?.description }}</p> -->
                          <!-- <div class="d-flex flex-wrap my-3">
                            <div class="d-flex align-items-center">
                              <div class="folder-ou">
                                <i class="pi pi-book v4-ml-2"></i>موقع يس
                              </div>
                              <div><i class="pi pi-chevron-left mx-1"></i></div>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="folder-ou">
                                <i class="pi pi-book v4-ml-2"></i>موقع يس
                              </div>
                              <div><i class="pi pi-chevron-left mx-1"></i></div>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="folder-ou">
                                <i class="pi pi-book v4-ml-2"></i>موقع يس
                              </div>
                              <div><i class="pi pi-chevron-left mx-1"></i></div>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="folder-ou">
                                <i class="pi pi-book v4-ml-2"></i>موقع يس
                              </div>
                              <div><i class="pi pi-chevron-left mx-1"></i></div>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="folder-ou">
                                <i class="pi pi-book v4-ml-2"></i>موقع يس
                              </div>
                              <div><i class="pi pi-chevron-left mx-1"></i></div>
                            </div>
                          </div> -->
                        </div>
                        <!-- extra single section end -->
                        <ng-container
                          *ngIf="
                            request?.courses.length > 0 &&
                            selectedProgram?._id == request._id
                          "
                        >
                        </ng-container>

                        <!-- Inner Training  -->
                        <ng-container
                          *ngIf="
                            request?.courses?.length > 0 &&
                            selectedProgram?._id == request._id
                          "
                        >
                          <h6 class="py-3">
                            {{ "Trainings in training Program" | translator }}
                          </h6>
                          <ng-container
                            *ngFor="
                              let training of request?.courses;
                              let i = index
                            "
                          >
                            <div class="row p-0">
                              <div class="col-md-1 col-12 p-0 2222">
                                <div class="tabel-detail-box adjustment">
                                  <div class="d-flex">
                                    <div
                                      data-label="#"
                                      class="ms-tabel-num-box"
                                    >
                                      <i
                                        (click)="inner.toggle($event)"
                                        class="fa fa-solid fa-chalkboard-user f-2rem-user"
                                      ></i>
                                    </div>
                                  </div>
                                  <div class="d-flex bold">
                                    {{ i + 1 }}
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                  <div data-label="la wasuf" class="tab-scroll">
                                    {{ training?.trainingId?.title }}
                                  </div>
                                </div>
                              </div>
                              <div
                                class="col-md-2 col-12 p-0"
                                *ngIf="training.ou; else ous"
                              >
                                <div class="tabel-detail-box">
                                  <div data-label="la wasuf" class="tab-scroll">
                                    {{ training?.ou?.name }} ({{
                                      training?.ou?.location?.name
                                    }})
                                  </div>
                                </div>
                              </div>
                              <ng-template #ous>
                                <div class="col-md-2 col-12 p-0">
                                  <div class="tabel-detail-box">
                                    <div
                                      data-label="la wasuf"
                                      class="tab-scroll"
                                    >
                                      {{ getNamesString(training?.ous) }}
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                              <div class="col-md-3 col-12 p-0">
                                <div class="tabel-detail-box">
                                  <div class="tab-scroll">
                                    {{ training.trainingId?.description }}
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                  <div
                                    class="tab-scroll d-flex align-items-center"
                                  >
                                    <div>
                                      {{
                                        training?.trainingId?.start_date | date
                                      }}
                                    </div>
                                    <div class="d-flex align-items-center mx-2">
                                      <i class="full-stop"></i>
                                      <div class="time-bar"></div>
                                      <i
                                        class="pi pi-arrow-left icon-purple"
                                      ></i>
                                    </div>
                                    <div>
                                      {{
                                        training?.trainingId?.end_date | date
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                *ngIf="status && status === 'CANCELED'"
                                class="col-md-2 col-12 p-0"
                              >
                                <div class="tabel-detail-box">
                                  <div class="tab-scroll">
                                    {{ request?.reason ?? request?.reason }}
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-2 col-12 p-0">
                                <div class="tabel-detail-box">
                                  <div class="tab-scroll d-flex flex-wrap">
                                    <div
                                      pTooltip="{{ 'amendment' | translator }}"
                                      tooltipPosition="top"
                                      *ngIf="
                                        ((training.status ===
                                          'TRAINING_CREATED' ||
                                          training.status === 'PUBLISHED' ||
                                          training.status == 'COMPLETED') &&
                                          hasPermission(
                                            'NEW_BRANCH_TRAINING',
                                            'u'
                                          )) ||
                                        hasPermission(
                                          'TRAINING_EDIT_ADMIN',
                                          'a'
                                        ) ||
                                        materTrainerPermission(
                                          training?.master_trainer
                                        )
                                      "
                                      (click)="openCourse(training)"
                                      class="tabel-circle-btn"
                                    >
                                      <i class="fa-solid fa-file-pen"></i>
                                    </div>

                                    <!-- <div
                                      pTooltip="{{ 'Publish' | translator }}"
                                      tooltipPosition="top"
                                      *ngIf="
                                        training.status ===
                                          'TRAINING_CREATED' &&
                                        training.status != 'PUBLISHED' &&
                                        (hasPermission(
                                          'NEW_BRANCH_TRAINING_PUBLISH',
                                          'a'
                                        ) ||
                                          materTrainerPermission(
                                            training?.master_trainer
                                          ))
                                      "
                                      (click)="publish(training)"
                                      class="tabel-circle-btn"
                                    >
                                      <i class="fa-solid fa-bullhorn"></i>
                                    </div> -->

                                    <div
                                      pTooltip="{{
                                        'User Management' | translator
                                      }}"
                                      [hidden]="
                                        !(
                                          materTrainerPermission(
                                            request?.master_trainer
                                          ) ||
                                          hasPermission(
                                            'NEW_BRANCH_TRAINING',
                                            'r'
                                          )
                                        )
                                      "
                                      (click)="
                                        changeRoute(
                                          '/training/user-management/',
                                            [training?.trainingId?._id]
                                        )
                                      "
                                      tooltipPosition="top"
                                      class="tabel-circle-btn"
                                    >
                                      <i class="fa-solid fa-user-gear"></i>
                                    </div>

                                    <!-- <div
                                      pTooltip="{{
                                        'Assign Users' | translator
                                      }}"
                                      tooltipPosition="top"
                                      *ngIf="
                                        training.status == 'PUBLISHED' &&
                                        (hasPermission(
                                          'NEW_BRANCH_TRAINING_PUBLISH',
                                          'a'
                                        ) ||
                                          materTrainerPermission(
                                            training?.master_trainer
                                          ) ||
                                          this.managerPage)
                                      "
                                      (click)="addAttendees(training)"
                                      class="tabel-circle-btn"
                                    >
                                      <i class="fa-solid fa-user-plus"></i>
                                    </div> -->

                                    <!-- <div
                                      pTooltip="{{
                                        'Delete training' | translator
                                      }}"
                                      [hidden]="
                                        !hasPermission(
                                          'NEW_BRANCH_TRAINING',
                                          'd'
                                        ) &&
                                        !materTrainerPermission(
                                          training?.master_trainer
                                        )
                                      "
                                      tooltipPosition="top"
                                      *ngIf="
                                        training.status !== 'PUBLISHED' &&
                                        training.status !== 'COMPLETED'
                                      "
                                      (click)="
                                        deleteRequest(training?.trainingId?._id)
                                      "
                                      class="tabel-circle-btn"
                                    >
                                      <i class="fa fa-trash"></i>
                                    </div> -->

                                    <!-- <div
                                      pTooltip="{{ 'Add to Kl' | translator }}"
                                      tooltipPosition="top"
                                      *ngIf="
                                        (training.status === 'PUBLISHED' ||
                                          training.status == 'COMPLETED') &&
                                        (hasPermission(
                                          'NEW_BRANCH_TRAINING',
                                          'u'
                                        ) ||
                                          hasPermission(
                                            'TRAINING_EDIT_ADMIN',
                                            'a'
                                          ) ||
                                          materTrainerPermission(
                                            training?.master_trainer
                                          ))
                                      "
                                      (click)="
                                        selectKLCourse = training;
                                        openAddKLModal = true
                                      "
                                      class="tabel-circle-btn"
                                    >
                                      <i class="pi pi-book"></i>
                                    </div> -->

                                    <div
                                      pTooltip="{{ 'Results' | translator }}"
                                      tooltipPosition="top"
                                      *ngIf="
                                        (training.status === 'PUBLISHED' ||
                                          training.status == 'COMPLETED') &&
                                        hasPermission(
                                          'NEW_BRANCH_TRAINING_PUBLISH',
                                          'a'
                                        )
                                      "
                                      class="tabel-circle-btn"
                                      [routerLink]="
                                        '/training/training-results/' +
                                        training?.trainingId?._id
                                      "
                                      [queryParams]="{
                                        back: '/training/new-branch'
                                      }"
                                    >
                                      <i class="pi pi-chart-bar"></i>
                                    </div>

                                    <div
                                      class="tabel-circle-btn"
                                      pTooltip="{{
                                        'Cancel training' | translator
                                      }}"
                                      tooltipPosition="top"
                                      *ngIf="
                                        training.status === 'PUBLISHED' &&
                                        (hasPermission(
                                          'NEW_BRANCH_TRAINING',
                                          'u'
                                        ) ||
                                          hasPermission(
                                            'TRAINING_EDIT_ADMIN',
                                            'a'
                                          ) ||
                                          materTrainerPermission(
                                            training?.master_trainer
                                          ))
                                      "
                                      (click)="
                                        rejectReason = true;
                                        rejectData.status = 'CANCELED';
                                        rejectData._id = training._id
                                      "
                                    >
                                      <i class="fa-solid fa-ban"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p-overlayPanel
                              class="v4-p-overlay-panel"
                              [style]="{ width: '500px' }"
                              #inner
                            >
                              <app-training-timeline
                                [sessions]="training?.trainingId?.sessions"
                                [isToolTip]="true"
                              ></app-training-timeline>
                            </p-overlayPanel>
                          </ng-container>
                        </ng-container>
                        <!-- End Inner Training  -->
                      </div>
                    </ng-container>
                    <!-- End Training Program -->
                  </ng-container>
                </div>
              </div>
              <div class="flex justify-content-center">
                <p-paginator
                  [hidden]="totalTraining <= 0"
                  (onPageChange)="onPageChange($event)"
                  [first]="first"
                  [rows]="rows"
                  [totalRecords]="totalTraining"
                  [rowsPerPageOptions]="[10, 20, 30]"
                ></p-paginator>
              </div>
              <!-- <table>
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ "the address" | translator }}</th>
                    <th scope="col">{{ "Entities" | translator }}</th>
                    <th scope="col">{{ "Description" | translator }}</th>
                    <th scope="col">{{ "the month" | translator }}</th>
                    <th scope="col" *ngIf="status && status === 'CANCELED'">
                      {{ "the reason of refuse" | translator }}
                    </th>
                    <th scope="col">{{ "Action" | translator }}</th>
                  </tr>
                </thead>

                <tbody>

                  <ng-container *ngFor="let request of filterRequestData; let i = index">

                    <tr *ngIf="!request.isProgram">

                      <td data-label="" style="width: 0px !important">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="d-flex tab-num-border-white">
                            <div class="tabel-detail-box">
                              <div class="ms-tabel-num-box">
                                {{ i + 1 }}
                              </div>
                            </div>
                          </div>
                        </span>
                      </td>
                      <td data-label="Main Criteria">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span class="tab-scroll">{{
                              request.title
                              }}</span>
                          </div>
                        </span>
                      </td>
                      <td data-label="Sub Criteria">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span class="tab-scroll">{{ request?.ou?.name }} ({{
                              request?.ou?.location?.name
                              }})</span>
                          </div>
                        </span>
                      </td>
                      <td class="fix-width" data-label="Factor">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span class="tab-scroll" [innerHTML]="
                              request.description | safeHTML
                            "></span>
                          </div>
                        </span>
                      </td>

                      <td data-label="Factor">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span class="tab-scroll">
                              {{ request.end_date | date }} -
                              {{ request?.trainingId?.start_date | date }}</span>
                          </div>
                        </span>
                      </td>

                      <td *ngIf="status && status === 'CANCELED'" data-label="Factor">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                          <div class="tabel-detail-box">
                            <span class="tab-scroll-for-column-ui" [innerHTML]="
                              request?.reason ?? request?.reason | safeHTML
                            "></span>
                          </div>
                        </span>
                      </td>

                      <td data-label="">
                        <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                         
                          <div class="tabel-detail-box">
                            <div class="tab-scroll">
                              <div pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top" *ngIf="
                                ((request.status === 'TRAINING_CREATED' ||
                                  request.status === 'PUBLISHED' ||
                                  request.status == 'COMPLETED') &&
                                  hasPermission('NEW_BRANCH_TRAINING', 'u')) ||
                                hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                                materTrainerPermission(request?.master_trainer)
                              " (click)="openCourse(request)" class="tabel-circle-btn">
                                <i class="fa-solid fa-file-pen"></i>
                              </div>
                            </div>

                            <div pTooltip="{{ 'Publish' | translator }}" tooltipPosition="top" *ngIf="
                              request.status === 'TRAINING_CREATED' &&
                              request.status != 'PUBLISHED' &&
                              (hasPermission('NEW_BRANCH_TRAINING_PUBLISH', 'a') ||
                                materTrainerPermission(request?.master_trainer))
                            " (click)="publish(request)" class="tabel-circle-btn">
                              <i class="fa-solid fa-bullhorn"></i>
                            </div>

                            <div pTooltip="{{ 'Assign Users' | translator }}" tooltipPosition="top" *ngIf="
                              request.status == 'PUBLISHED' &&
                              (hasPermission('NEW_BRANCH_TRAINING_PUBLISH', 'a') ||
                                materTrainerPermission(request?.master_trainer) ||
                                this.managerPage)
                            " (click)="addAttendees(request)" class="tabel-circle-btn">
                              <i class="fa-solid fa-user-plus"></i>
                            </div>

                            <div pTooltip="{{ 'Delete training' | translator }}" [hidden]="
                              !hasPermission('NEW_BRANCH_TRAINING', 'd') &&
                              !materTrainerPermission(request?.master_trainer)
                            " tooltipPosition="top" *ngIf="
                              request.status !== 'PUBLISHED' &&
                              request.status !== 'COMPLETED'
                            " (click)="deleteRequest(request?.trainingId?._id)" class="tabel-circle-btn">
                              <i class="fa fa-trash"></i>
                            </div>

                            <div pTooltip="{{ 'Add to Kl' | translator }}" tooltipPosition="top" *ngIf="
                              (request.status === 'PUBLISHED' ||
                                request.status == 'COMPLETED') &&
                              (hasPermission('NEW_BRANCH_TRAINING', 'u') ||
                                hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                                materTrainerPermission(request?.master_trainer))
                            " (click)="
                              selectKLCourse = request; openAddKLModal = true
                            " class="tabel-circle-btn">
                              <i class="pi pi-book"></i>
                            </div>

                            <div pTooltip="{{ 'Results' | translator }}" tooltipPosition="top" *ngIf=" (request.status === 'PUBLISHED' ||
                          request.status == 'COMPLETED') &&
                          hasPermission('NEW_BRANCH_TRAINING_PUBLISH', 'a')" class="tabel-circle-btn"
                              [routerLink]="'/training/training-results/' + request?.trainingId._id"
                              [queryParams]="{ back: '/training/new-branch' }">
                              <i class="pi pi-chart-bar"></i>
                            </div>

                            <div class="tabel-circle-btn" pTooltip="{{ 'Cancel training' | translator }}"
                              tooltipPosition="top" *ngIf="
                              request.status === 'PUBLISHED' &&
                              (hasPermission('NEW_BRANCH_TRAINING', 'u') ||
                                hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                                materTrainerPermission(request?.master_trainer))
                            " (click)="
                              rejectReason = true;
                              rejectData.status = 'CANCELED';
                              rejectData._id = request._id
                            ">
                              <i class="fa-solid fa-ban"></i>
                            </div>
                          </div>
                       
                        </span>
                      </td>
                    </tr>






                  </ng-container>

                </tbody>
              </table> -->
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <p-progressSpinner
            [hidden]="!spinner"
            styleClass="w-4rem h-4rem pb-4"
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          ></p-progressSpinner>
        </div>
        <!-- New UI Table -->
        <!-- End New UI Table -->
      </section>

      <!-- End Trainings Not In Program -->
    </ng-container>
  </div>
  <app-training-dashboard
    *ngIf="
      ShowDashboard &&
      !createCourseModal &&
      !openCourseModal &&
      !showCalender &&
      !addTrainer &&
      !addTrainingProgram
    "
    [tab]="'New Branch'"
  >
  </app-training-dashboard>

  <app-training-calander
    *ngIf="
      showCalender &&
      !ShowDashboard &&
      !createCourseModal &&
      !openCourseModal &&
      !addTrainer &&
      !addTrainingProgram
    "
    [training_type]="this.selected"
    (showTraining)="openCourse($event, true)"
  ></app-training-calander>

  <!-- Create Training Progaram -->
  <div *ngIf="addTrainingProgram" class="container bg-rgb mb-3 p-3">
    <ng-container *ngIf="addTrainingProgram && !updateHolder">
      <app-add-training-program
        (closeForm)="closeProgramAddFrom($event)"
        [isSkillTraining]="false"
        [programType]="'654e867bb9f4c5b8996191c5'"
      ></app-add-training-program>
    </ng-container>
    <ng-container *ngIf="addTrainingProgram && updateHolder">
      <app-add-training-program
        [programData]="updateHolder"
        (closeForm)="closeProgramAddFrom($event)"
        [programType]="'654e867bb9f4c5b8996191c5'"
        [isSkillTraining]="false"
      ></app-add-training-program>
    </ng-container>
  </div>

  <!-- End Create Training Progaram -->

  <section
    class=""
    *ngIf="createCourseModal && !openCourseModal && !addTrainer"
  >
    <app-create-course
      [data]="requestHolder"
      [newBranchTraining]="true"
      [fromCreateTraining]="fromCreateTraining"
    ></app-create-course>
  </section>
  <section
    class=""
    *ngIf="openCourseModal && !createCourseModal && !addTrainer"
  >
    <app-show-detail
      [pageCall]="'View'"
      *ngIf="trainingDetails != undefined"
      [permissions]="permissions"
      [courseDetails]="trainingDetails"
    ></app-show-detail>
  </section>

  <!-- Assign User -->
  <section *ngIf="addTrainer">
    <app-assign-users
      [userFetchUrl]="'user/training-users/'"
      [selectionData]="usersInCourse"
      (selectedUsersList)="assNewTrainers($event)"
      [query]="{ ous: [course?.ou?._id], training: course._id }"
      *ngIf="addTrainer"
      [isTraining]="true"
    >
    </app-assign-users>
  </section>
  <!-- Assign User -->

  <app-footer></app-footer>

  <!-- Accept Reject Modal -->
  <div class="card flex justify-content-center">
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'the reason' | translator }}"
      [(visible)]="rejectReason"
      [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '600px' }"
      [maximizable]="true"
    >
      <div class="w-100">
        <p>{{ "the reason" | translator }}</p>
        <p-editor [(ngModel)]="rejectData.reason" [style]="{ height: '320px' }">
        </p-editor>
        <p *ngIf="reasonError" style="color: red">{{ reasonError }}</p>
      </div>
      <ng-template pTemplate="footer">
        <p-button
          icon="pi pi-check"
          (click)="deactivateInit()"
          label="{{ 'OK' | translator }}"
          styleClass="p-button-text"
        ></p-button>
      </ng-template>
    </p-dialog>
  </div>

  <!-- AssessMent Result Modal -->
  <p-dialog
    header="{{ 'Results' | translator }}"
    [(visible)]="showSelectAssessmentModal"
    [style]="{ width: '50vw' }"
  >
    <p-tabView class="v4-tabview">
      <p-tabPanel
        *ngIf="
          getAssessmentSessions(
            selectCourseForAssessmentResult?.trainingId?.sessions
          ).length > 0
        "
        [header]="'Assessments' | translator"
      >
        <div
          class="w-100 d-flex flex-column align-items-start justify-content-start gap-2"
        >
          <ng-container
            *ngFor="
              let session of getAssessmentSessions(
                selectCourseForAssessmentResult?.trainingId?.sessions
              )
            "
          >
            <span
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span style="color: white">{{ session?.title }}</span>
              <a
                (click)="openResults(session)"
                pTooltip="{{ 'Open Results' | translator }}"
                tooltipPosition="top"
                class="tabel-circle-btn"
                ><i class="pi pi-external-link"></i
              ></a>
            </span>
            <div
              class="w-100"
              style="height: 2px; background-color: rgb(228, 228, 228)"
            ></div>
          </ng-container>
        </div>
      </p-tabPanel>
      <p-tabPanel
        *ngIf="
          getSurveySessions(
            selectCourseForAssessmentResult?.trainingId?.sessions
          ).length > 0
        "
        [header]="'Surveys' | translator"
      >
        <div
          class="w-100 d-flex flex-column align-items-start justify-content-start gap-2"
        >
          <ng-container
            *ngFor="
              let session of getSurveySessions(
                selectCourseForAssessmentResult?.trainingId?.sessions
              )
            "
          >
            <span
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span style="color: white">{{ session?.title }}</span>
              <a
                (click)="openResults(session)"
                pTooltip="{{ 'Open Results' | translator }}"
                tooltipPosition="top"
                class="tabel-circle-btn"
                ><i class="pi pi-external-link"></i
              ></a>
            </span>
            <div
              class="w-100"
              style="height: 2px; background-color: rgb(228, 228, 228)"
            ></div>
          </ng-container>
        </div>
      </p-tabPanel>
    </p-tabView>
  </p-dialog>

  <!-- Publish Modal -->
  <p-dialog
    [blockScroll]="true"
    [draggable]="false"
    header="Header"
    [(visible)]="publishModal"
    (onHide)="clearPublishDetails()"
    [style]="{ width: '90vw' }"
  >
    <ng-template pTemplate="header">
      <span class="text-xl font-bold">{{
        "Publish Details" | translator
      }}</span>
    </ng-template>
    <div class="flex flex-column">
      <div class="column">
        <label class="label-ui my-1">{{ "Entities" | translator }}</label>
        <p-treeSelect
          class="ppp-tree-select"
          appendTo="body"
          class="w-md-20rem w-100"
          containerStyleClass="w-100"
          [(ngModel)]="branchId"
          [options]="selectedTreeData"
          placeholder="{{ 'Select the organizational unit' | translator }}"
          [filter]="true"
          [filterInputAutoFocus]="true"
          (onNodeSelect)="branchId = $event.node"
        >
          <ng-template let-node pTemplate="default">
            <div class="d-flex">
              <img
                *ngIf="checkisImg(node.data); else elseBlock"
                src="{{ staticURL }}{{ node.data }}"
                class="img-fluid p-1 tree-img-bg"
                style="max-height: 30px; max-width: 30px"
              />
              <ng-template #elseBlock>
                <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
              </ng-template>
              <b class="text-nowrap">{{ node.label }}</b>
            </div>
          </ng-template>
        </p-treeSelect>
        <p *ngIf="!branchId" style="color: red">
          {{ "Branch is required" | translator }}
        </p>
      </div>

      <div class="p-fluid w-100">
        <label class="mb-1 label-ui" for="externals">{{
          "Add emails survey" | translator
        }}</label>
        <p-chips
          [addOnBlur]="true"
          [addOnTab]="true"
          name="externals"
          class="p-chipp"
          [(ngModel)]="unregisteredUsers"
        ></p-chips>
      </div>

      <div
        *ngIf="this.branchUser == undefined"
        class="d-flex justify-content-center"
      >
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div
        *ngIf="this.branchUser != undefined && this.branchUser?.length >= 0"
        class=""
      >
        <label class="label-ui my-2">{{
          "Training Attendees" | translator
        }}</label>
        <p-table
          [value]="this.branchUser"
          [tableStyle]="{ 'min-width': '50rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>{{ "the name" | translator }}</th>
              <th>{{ "Email" | translator }}</th>
              <th>{{ "Gender" | translator }}</th>
              <th>{{ "National ID" | translator }}</th>
              <th>{{ "Phone Number" | translator }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-trainer>
            <tr>
              <td>
                {{ trainer?.name?.first }} {{ trainer?.name?.middle }}
                {{ trainer?.name?.last }}
              </td>
              <td>{{ trainer?.email }}</td>
              <td>{{ trainer?.gender }}</td>
              <td>{{ trainer?.national_id }}</td>
              <td>{{ trainer?.phone }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button
        icon="pi pi-check"
        label="{{ 'publish' | translator }}"
        (onClick)="submitPublish()"
      ></p-button>
    </ng-template>
  </p-dialog>
  <!-- End Publish Modal -->

  <p-dialog
    header="{{ 'Add to Kl' | translator }}"
    [(visible)]="openAddKLModal"
    [style]="{ width: '90vw' }"
  >
    <app-add-training-kl
      *ngIf="openAddKLModal"
      [courseId]="selectKLCourse._id"
      [ou]="selectKLCourse.ou._id"
      (submitSucces)="librarySubmit($event)"
    ></app-add-training-kl>
  </p-dialog>

  <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
</div>

<p-toast></p-toast>
